import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { beforeAfter } from '../data/content';

/** Short before/after right after the stats band. Stacked on mobile, side by side from md. No button. */
export function BeforeAfter() {
  const {
    before,
    after
  } = beforeAfter;
  return <section aria-labelledby="before-after-title" className="bg-white py-10 md:py-16" data-id="element-19" data-mp="3sh378rd9tk5a">
      <div className="mx-auto max-w-[900px] px-5 md:px-8" data-id="element-20" data-mp="3epydg5wl3m2v">
        <h2 id="before-after-title" className="text-center font-display text-[1.35rem] font-black uppercase leading-tight tracking-tight text-brand md:text-[1.8rem]" data-id="element-21" data-mp="3eode82zbreyo">
          {beforeAfter.title}
        </h2>

        <div className="mt-6 grid gap-3 md:mt-8 md:grid-cols-2 md:gap-4" data-id="element-22" data-mp="34ppbebfwv6fk">
          <div className="rounded-2xl border border-coral/30 bg-coral-soft p-5 md:p-6" data-id="element-23" data-mp="39rn37u2dn9k4">
            <div className="flex items-baseline justify-between gap-3" data-id="element-24" data-mp="2vs59d0a8563w">
              <span className="rounded-md bg-coral px-2 py-1 font-display text-[11px] font-black tracking-[0.12em] text-ink" data-id="element-25" data-mp="30qow32wn6lxb">{before.label}</span>
              <span className="font-display text-[14px] font-extrabold text-coral-ink" data-id="element-26" data-mp="x2z8f8hukb7w">{before.when}</span>
            </div>
            <p className="mt-4 font-display text-[19px] font-extrabold leading-snug text-ink" data-id="element-27" data-mp="t5b97t94fwa7">{before.quote}</p>
            <ul className="mt-3 space-y-2" data-id="element-28" data-mp="123n8ejo202e9">
              {before.items.map(item => <li key={item} className="flex items-center gap-2.5 text-[16px] text-ink/80" data-id="element-29" data-mp="121u2x7p6fo7u">
                  <XIcon className="h-4 w-4 shrink-0 text-coral-ink" strokeWidth={3} aria-hidden="true" data-id="element-30" data-mp="ebpxcusfhee7" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-brand p-5 md:p-6" data-id="element-31" data-mp="o5oxxpcusq41">
            <div className="flex items-baseline justify-between gap-3" data-id="element-32" data-mp="jcdnzfcqvt7w">
              <span className="rounded-md bg-sun px-2 py-1 font-display text-[11px] font-black tracking-[0.12em] text-ink" data-id="element-33" data-mp="3rsfk3tul2o3u">{after.label}</span>
              <span className="font-display text-[14px] font-extrabold text-sun" data-id="element-34" data-mp="3mtm2pqc6ecye">{after.when}</span>
            </div>
            <ul className="mt-4 space-y-2.5" data-id="element-35" data-mp="1qowt7kjxu67e">
              {after.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[17px] font-semibold leading-snug text-white" data-id="element-36" data-mp="1vnpumelya6r7">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-leaf text-white" data-id="element-37" data-mp="24i4jn8wa8vni">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-38" data-mp="17sn7cb2sobcu" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}